import React from 'react';
import {Helmet} from 'react-helmet-async';
import Header from '../components/header';
import Footer from '../components/footer';
import './case-study-page.css';
import {useTranslation} from 'react-i18next';

const CaseStudyCiCd = ({showCalModal}) => {
    const {t} = useTranslation();

    const footerMenuItems = [
        <a href="/#home-section-home"><span className="Large">{t("footer_menu-home")}</span></a>,
        <a href="/#problems-solutions"><span className="Large">{t("footer_menu-problems-solutions")}</span></a>,
        <a href="/#profile-section"><span className="Large">{t("footer_menu-about-me")}</span></a>,
        <a href="/legal"><span className="Large">{t("footer_menu-impressum")}</span></a>,
        <a href="/privacy"><span className="Large">{t("footer_menu-privacy")}</span></a>
    ];

    return (
        <div className="case-study-container">
            <Helmet>
                <title>{t("case-study_ci-cd_title")}</title>
                <meta name="description" content={t("case-study_ci-cd_meta-description")}/>
                <meta property="og:title" content={t("case-study_ci-cd_meta-og-title")}/>
                <meta property="og:description" content={t("case-study_ci-cd_meta-og-description")}/>
            </Helmet>

            <Header showCalModal={showCalModal}/>

            <section className="case-study-hero">
                <h1 className="case-study-title">{t("case-study_ci-cd_title")}</h1>
            </section>

            <main className="case-study-content">
                <section className="case-study-section">
                    <h2 className="case-study-section-title HeadingOne">{t("case-study_ci-cd_overview-title")}</h2>
                    <p className="case-study-body">{t("case-study_ci-cd_overview-text")}</p>
                </section>

                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study_ci-cd_challenges-title")}</h2>
                    <article className="case-study-article">
                        <h3 className="case-study-subtitle">{t("case-study_ci-cd_key-challenges-title")}</h3>
                        <ul className="case-study-body">
                            <li>
                                <strong>{t("case-study_ci-cd_challenge-scalability")}</strong> {t("case-study_ci-cd_challenge-scalability-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_challenge-time-market")}</strong> {t("case-study_ci-cd_challenge-time-market-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_challenge-testing-strategy")}</strong> {t("case-study_ci-cd_challenge-testing-strategy-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_challenge-speed-reliability")}</strong> {t("case-study_ci-cd_challenge-speed-reliability-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_challenge-infrastructure")}</strong> {t("case-study_ci-cd_challenge-infrastructure-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_challenge-knowledge-transfer")}</strong> {t("case-study_ci-cd_challenge-knowledge-transfer-text")}
                            </li>
                        </ul>
                    </article>
                </section>

                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study_ci-cd_solution-title")}</h2>
                    <article className="case-study-article">

                        <h3 className="case-study-subtitle">{t("case-study_ci-cd_ci-cd-pipelines-title")}</h3>
                        <p className="case-study-body"><strong>{t("case-study_ci-cd_ci-cd-mvp-title")}</strong></p>
                        <ul className="case-study-body">
                            <li>
                                <strong>{t("case-study_ci-cd_ci-cd-mvp-point-1-title")}</strong> {t("case-study_ci-cd_ci-cd-mvp-point-1-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_ci-cd-mvp-point-2-title")}</strong> {t("case-study_ci-cd_ci-cd-mvp-point-2-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_ci-cd-mvp-point-3-title")}</strong> {t("case-study_ci-cd_ci-cd-mvp-point-3-text")}
                            </li>
                        </ul>
                        <p className="case-study-body"><strong>{t("case-study_ci-cd_ci-cd-enterprise-title")}</strong>
                        </p>
                        <ul className="case-study-body">
                            <li>
                                <strong>{t("case-study_ci-cd_ci-cd-enterprise-point-1-title")}</strong> {t("case-study_ci-cd_ci-cd-enterprise-point-1-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_ci-cd-enterprise-point-2-title")}</strong> {t("case-study_ci-cd_ci-cd-enterprise-point-2-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_ci-cd-enterprise-point-3-title")}</strong> {t("case-study_ci-cd_ci-cd-enterprise-point-3-text")}
                            </li>
                        </ul>
                    </article>
                    <article className="case-study-article">
                        <h2 className="case-study-section-title">{t("case-study_ci-cd_bottlenecks-title")}</h2>
                        <ul className="case-study-body">
                            <li>
                                <strong>{t("case-study_ci-cd_bottlenecks-point-1-title")} </strong>{t("case-study_ci-cd_bottlenecks-point-1-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_bottlenecks-point-2-title")} </strong>{t("case-study_ci-cd_bottlenecks-point-2-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_bottlenecks-point-3-title")} </strong>{t("case-study_ci-cd_bottlenecks-point-3-text")}
                            </li>
                        </ul>
                    </article>

                    <article className="case-study-article">
                        <h2 className="case-study-section-title">{t("case-study_ci-cd_deployment-strategies-title")}</h2>
                        <ul className="case-study-body">
                            <li>
                                <strong>{t("case-study_ci-cd_deployment-strategies-point-1-title")} </strong>{t("case-study_ci-cd_deployment-strategies-point-1-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_deployment-strategies-point-2-title")} </strong>{t("case-study_ci-cd_deployment-strategies-point-2-text")}
                            </li>
                            <li>
                                <strong>{t("case-study_ci-cd_deployment-strategies-point-3-title")} </strong>{t("case-study_ci-cd_deployment-strategies-point-3-text")}
                            </li>
                        </ul>
                    </article>

                    <div className={"image-container"}>
                        <div className={"image"}>
                            <img src={"/ci_cd_pipeline_architecture.png"}/>
                        </div>
                    </div>
                </section>

                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study_ci-cd_why-ci-cd-title")}</h2>
                    <p className="case-study-body">{t("case-study_ci-cd_why-ci-cd-text")}</p>
                    <ul className="case-study-body">
                        <li>❌ {t("case-study_ci-cd_why-ci-cd-problem-1")}</li>
                        <li>❌ {t("case-study_ci-cd_why-ci-cd-problem-2")}</li>
                        <li>❌ {t("case-study_ci-cd_why-ci-cd-problem-3")}</li>
                        <li>❌ {t("case-study_ci-cd_why-ci-cd-problem-4")}</li>
                    </ul>
                    <p className="case-study-body">{t("case-study_ci-cd_why-ci-cd-benefit-title")}</p>
                    <ul className="case-study-body">
                        <li>✅ {t("case-study_ci-cd_why-ci-cd-benefit-1")}</li>
                        <li>✅ {t("case-study_ci-cd_why-ci-cd-benefit-2")}</li>
                        <li>✅ {t("case-study_ci-cd_why-ci-cd-benefit-3")}</li>
                        <li>✅ {t("case-study_ci-cd_why-ci-cd-benefit-4")}</li>
                    </ul>
                </section>

                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study_ci-cd_cost-benefit-title")}</h2>
                    <p className="case-study-body">{t("case-study_ci-cd_cost-benefit-text")}</p>
                </section>

                <section className="case-study-section">
                    <h2 className="case-study-section-title">{t("case-study_ci-cd_consulting-title")}</h2>
                    <p className="case-study-body">{t("case-study_ci-cd_consulting-text")}</p>
                    <ul className="case-study-body">
                        <li>🛠 {t("case-study_ci-cd_consulting-service-1")}</li>
                        <li>🔍 {t("case-study_ci-cd_consulting-service-2")}</li>
                        <li>🚀 {t("case-study_ci-cd_consulting-service-3")}</li>
                        <li>📚 {t("case-study_ci-cd_consulting-service-4")}</li>
                    </ul>
                    <p className="case-study-body">{t("case-study_ci-cd_consulting-call-to-action")}</p>
                </section>
            </main>

            <Footer footerMenuItems={footerMenuItems}/>
        </div>
    );
};

export default CaseStudyCiCd;
